export const quickDonate = () => {
    const donationAmountsList = document.querySelector('#Donation_amounts') as HTMLElement;
    const donationInput = document.querySelector('#Amounts_custom-field') as HTMLInputElement;
    const customRadio = document.querySelector('[data-custom-radio]') as HTMLInputElement;
    const customRadioContainer = document.querySelector('[data-custom-radio-container]') as HTMLElement;
    const customMinimumAmountElt = document.querySelector('#CurrentPage_MinimumDonationAmount') as HTMLInputElement;
    const customMinimumAmount = customMinimumAmountElt ? parseInt(customMinimumAmountElt.value) : 0;
    const customMinError = document.querySelector('[data-amount-min-error]') as HTMLElement; 
    const allCustomErrors = Array.from(document.querySelectorAll('[data-replaces-server-error]')) as Array<HTMLElement>;

    if (donationAmountsList && donationInput) {
        const allRadios = Array.prototype.slice.call(donationAmountsList.querySelectorAll('input'));

        donationInput.addEventListener('change', () => {
            const newValue = parseInt(donationInput.value);
            if (newValue) {
                allRadios.forEach(radio => {
                    if (parseInt(radio.value) == newValue) {
                        radio.checked = true;
                    }
                    else {
                        radio.checked = false;
                    }
                })
            }
        });

        donationInput.addEventListener('blur', () => {
            if (customMinError) {
                if (parseInt(donationInput.value) < customMinimumAmount) {
                    customMinError.hidden = false;
                }
                else {
                    customMinError.hidden = true;
                }
            }
        });

        allRadios.forEach(radio => {
            if (radio.checked) {
                donationInput.value = radio.value;
            }
            radio.addEventListener('change', () => {
                allRadios.forEach(radio_ => {
                    if (radio_.checked) {
                        donationInput.value = radio_.value;
                    }
                });
                handleCustomAmountField();
            });
        });

        if (customRadio.checked) {
            setTimeout(() => {
                customRadioContainer.setAttribute("aria-hidden", "false")
                customRadio.value = customRadio.value
            }, 1000)
        }
    }
    const handleCustomAmountField = () => {

        if (customRadio.checked) {
            customRadioContainer.setAttribute("aria-hidden", "false")
            donationInput.focus();
        }

        else {
            customRadioContainer.setAttribute("aria-hidden", "true")
        }
    }

    allCustomErrors.forEach(customError => {
        const nameOfErrorToReplace = customError.getAttribute('data-replaces-server-error');
        const errorToReplace = document.querySelector(`[data-server-error="${nameOfErrorToReplace}"]`) as HTMLElement;

        const hiddenObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
                    if (!customError.hidden) {
                        errorToReplace.hidden = true;
                    }
                }
            });
        });

        hiddenObserver.observe(customError, {
            attributes: true,
            attributeFilter: ['hidden']
        });
    })
}